import React from 'react';
import { Card, Row, Stack, Text } from 'library/ui';

export function ProgressItem({
    text,
    to,
    icon,
    onClick,
}: {
    text: string;
    to?: string;
    icon: React.ReactElement;
    onClick?: () => void;
}) {
    const content = (
        <Row justify="between" align="center">
            <Stack gap="none" grow>
                <Text weight="semibold">{text}</Text>
            </Stack>
            {icon}
        </Row>
    );

    if (to) {
        return (
            <Card to={to} padding="sm" tone="muted">
                {content}
            </Card>
        );
    }

    if (onClick) {
        return (
            <Card onClick={onClick} padding="sm" tone="muted">
                {content}
            </Card>
        );
    }

    return (
        <Card padding="sm" tone="muted">
            {content}
        </Card>
    );
}
